import P from "../../pages";
import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { defaultMessages } from "../../../../libs/i18n/default";
import ReactOnRails from "react-on-rails";
import FormHeader from "./FormHeader";
import Redirector from "./Redirector";
import ControlLabel from "react-bootstrap/lib/ControlLabel";
import FormControl from "react-bootstrap/lib/FormControl";
import Alert from "./Alert";
import ButtonGroup from "./ButtonGroup";
import Ssn from "./Ssn";
import ReactMarkdown from "react-markdown";
import Dollar from "react-icons/lib/fa/dollar";
import CustomFormGroup from "./CustomFormGroup";
import { pageValid, executeValidations } from "../../validator";
import { changeState, obfuscateString } from "../../utilities";

class Payments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bankName: { val: this.props.user.host.bank_name, validationKey: "attributes_bank_name" },
      bankAccountName: {
        val: this.props.user.host.bank_account_name,
        validationKey: "attributes_bank_account_name",
      },
      bankCode: {
        val: obfuscateString(this.props.user.host.bank_code),
        validationKey: this.props.territory.include_bank_bsb ? "attributes_bank_code" : null,
      },
      bankAccountNumber: {
        val: obfuscateString(this.props.user.host.bank_account_number),
        validationKey: "attributes_bank_account_number",
      },
      taxSsn: { val: this.props.user.host.tax_ssn, validationKey: "attributes_tax_ssn" },
      taxSsnName: {
        val: this.props.user.host.tax_ssn_name,
        validationKey: "attributes_tax_ssn_name",
      },
    };
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.skip = this.skip.bind(this);
    this.changeState = this.changeState.bind(this);
    this.handleSsn = this.handleSsn.bind(this);
  }

  getInitialState() {
    return {
      submitted: false,
    };
  }

  componentWillMount() {
    executeValidations(this);
  }

  componentDidMount() {
    this.maskBankAccountNumber();
  }

  maskBankAccountNumber() {
    if (!this.props.territory.bank_account_number_input_mask) return;

    const _this = this;
    const options = {
      completed: function () {
        _this.changeState("bankAccountNumber", this.val());
      },
    };
    $("#bankAccountNumber").mask(this.props.territory.bank_account_number_input_mask, options);
  }

  changeState = async (id, val) => {
    changeState(this, id, val);
  };

  handleSsn(ssn) {
    this.changeState("taxSsn", ssn);
  }

  back = (e) => {
    e.preventDefault();
    this.props.onGoBack();
  };

  skip = (e) => {
    e.preventDefault();
    this.props.onSkipSubmit();
  };

  submit = (e) => {
    this.props.onPaymentsSubmit({
      authenticity_token: ReactOnRails.authenticityToken(),
      host: {
        bank_account_name: this.state.bankAccountName.val,
        bank_account_number: this.state.bankAccountNumber.val,
        bank_name: this.state.bankName.val,
        bank_code: this.state.bankCode.val,
        tax_ssn: this.state.taxSsn.val,
        tax_ssn_name: this.state.taxSsnName.val,
      },
    });
  };

  render() {
    const thisPage = P.PAYMENTS_PAGE;
    const content = this.props.content;
    const page = this.props.page;
    const { formatMessage } = this.props.intl;

    return (
      <div id={page} className="profile">
        <Redirector this_page={thisPage} page={page} />
        <form>
          <FormHeader title={content.pages.payments.title} icon={<Dollar />} />
          <img src="/images/host-sign-up/secure.png" className="pull-right" />
          <ReactMarkdown source={content.pages.payments.body} />
          <div className="form-container">
            <ControlLabel>
              {formatMessage(defaultMessages.clientHostPagesPaymentsLabelsBankDetails)}
            </ControlLabel>
            <CustomFormGroup valid={this.state.bankName.valid}>
              <FormControl
                id="bankName"
                placeholder={formatMessage(
                  defaultMessages.clientHostPagesPaymentsPlaceholdersBankName,
                )}
                type="text"
                componentClass="input"
                defaultValue={this.state.bankName.val}
                onChange={(e) => this.changeState(e.target.id, e.target.value)}
              />
            </CustomFormGroup>
            <CustomFormGroup valid={this.state.bankAccountName.valid}>
              <FormControl
                id="bankAccountName"
                placeholder={formatMessage(
                  defaultMessages.clientHostPagesPaymentsPlaceholdersBankAccountName,
                )}
                type="text"
                componentClass="input"
                defaultValue={this.state.bankAccountName.val}
                onChange={(e) => this.changeState(e.target.id, e.target.value)}
              />
            </CustomFormGroup>
            {this.props.territory.include_bank_bsb && (
              <CustomFormGroup valid={this.state.bankCode.valid}>
                <FormControl
                  id="bankCode"
                  placeholder={content.bank_code}
                  type="text"
                  componentClass="input"
                  defaultValue={this.state.bankCode.val}
                  onChange={(e) => this.changeState(e.target.id, e.target.value)}
                  onBlur={(e) => this.changeState(e.target.id, e.target.value)}
                />
              </CustomFormGroup>
            )}
            <CustomFormGroup valid={this.state.bankAccountNumber.valid}>
              <FormControl
                id="bankAccountNumber"
                placeholder={formatMessage(
                  defaultMessages.clientHostPagesPaymentsPlaceholdersAccountNumber,
                )}
                type="text"
                componentClass="input"
                defaultValue={this.state.bankAccountNumber.val}
                onChange={(e) => this.changeState(e.target.id, e.target.value)}
              />
            </CustomFormGroup>
            {content.territory_code == "usa" && (
              <div>
                <ControlLabel>
                  {formatMessage(defaultMessages.clientHostPagesPaymentsLabelsSsn)}
                </ControlLabel>
                <p>{content.pages.payments.ssn}</p>
              </div>
            )}
            <Ssn
              ssn={this.state.taxSsn.val ? this.state.taxSsn.val.replace(/^.{6}/g, "******") : ""}
              content={content}
              handleSelection={this.handleSsn}
              valid={this.state.taxSsn.valid}
            />
            {content.territory_code == "usa" && (
              <div>
                <ControlLabel>
                  {formatMessage(defaultMessages.clientHostPagesPaymentsLabelsSsnName)}
                </ControlLabel>
                <p>{content.pages.payments.ssn_name}</p>

                <CustomFormGroup valid={this.state.taxSsnName.valid}>
                  <FormControl
                    id="taxSsnName"
                    placeholder="Name associated with SSN"
                    type="text"
                    componentClass="input"
                    defaultValue={this.state.taxSsnName.val}
                    onChange={(e) => this.changeState(e.target.id, e.target.value)}
                  />
                </CustomFormGroup>
              </div>
            )}
          </div>

          <Alert alert={content.pages.payments.info} />

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            skipFunc={this.skip}
            intl={this.props.intl}
            page={thisPage}
            user={this.props.user}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
          />
        </form>
      </div>
    );
  }
}

Payments.propTypes = {
  onPaymentsSubmit: PropTypes.func,
  onSkipSubmit: PropTypes.func,
  onGoBack: PropTypes.func,
  page: PropTypes.string,
  intl: PropTypes.object,
  content: PropTypes.object,
};

export default injectIntl(Payments);
